export default __webpack_public_path__ + "static/media/0x403e967b044d4be25170310157cb1a4bf10bdd0f.96f3ff4a.webp";